var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-modal", {
    attrs: {
      size: "xl",
      title: "Buscar Contato",
      "ok-only": "",
      id: "search-contact"
    },
    on: { ok: _vm.emitSelections },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c("div", { staticClass: "pb-1" }, [
              _c("label", { staticClass: "font-bold mb-1" }, [
                _vm._v(" Buscar em ")
              ]),
              _c(
                "div",
                { staticClass: "flex gap-5 pl-2" },
                [
                  _c(
                    "b-form-radio",
                    {
                      attrs: { value: "contact" },
                      model: {
                        value: _vm.displayMode,
                        callback: function($$v) {
                          _vm.displayMode = $$v
                        },
                        expression: "displayMode"
                      }
                    },
                    [_vm._v("Contatos")]
                  ),
                  _c(
                    "b-form-radio",
                    {
                      attrs: { value: "list" },
                      model: {
                        value: _vm.displayMode,
                        callback: function($$v) {
                          _vm.displayMode = $$v
                        },
                        expression: "displayMode"
                      }
                    },
                    [_vm._v("Listas")]
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "pb-1" }, [
              _c("label", { staticClass: "font-bold mb-1" }, [
                _vm._v(" Contatos Selecionados "),
                _c("span", [
                  _vm._v("(" + _vm._s(_vm.selectedContacts.length) + ")")
                ])
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "overflow-y-auto rounded bg-grey-light bg-opacity-25 p-1",
                  staticStyle: { "max-height": "10rem" }
                },
                [
                  _c(
                    "table",
                    { staticClass: "pl-2" },
                    [
                      _vm.selectedContacts.length == 0
                        ? _c("tr", [
                            _vm._v(" Nenhum contato foi selecionado ainda ")
                          ])
                        : _vm._e(),
                      _vm._l(_vm.selectedContacts, function(contact, i) {
                        return _c("tr", { key: i }, [
                          _c("td", { staticStyle: { "min-width": "10rem" } }, [
                            _vm._v(_vm._s(contact.name))
                          ]),
                          _c("td", { staticClass: "font-semibold" }, [
                            _vm._v(_vm._s(contact.email))
                          ])
                        ])
                      })
                    ],
                    2
                  )
                ]
              )
            ]),
            _c("Grid", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.displayList,
                  expression: "displayList"
                }
              ],
              ref: "list_grid",
              attrs: {
                hide_actions: "",
                "select-hook": _vm.completeModel,
                "multiple-select": "",
                service: _vm.listService
              },
              on: { changedSelection: _vm.updateSelectedContacts },
              scopedSlots: _vm._u([
                {
                  key: "actions",
                  fn: function() {
                    return undefined
                  },
                  proxy: true
                }
              ])
            }),
            _c("Grid", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.displayContact,
                  expression: "displayContact"
                }
              ],
              ref: "contact_grid",
              attrs: {
                hide_actions: "",
                "select-hook": _vm.completeModel,
                "multiple-select": "",
                service: _vm.contactService
              },
              on: { changedSelection: _vm.updateSelectedContacts },
              scopedSlots: _vm._u([
                {
                  key: "actions",
                  fn: function() {
                    return undefined
                  },
                  proxy: true
                }
              ])
            })
          ]
        },
        proxy: true
      },
      {
        key: "modal-ok",
        fn: function() {
          return [_vm._v(" Adicionar ")]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }